<template>
  <div class="userdetail">
    <div class="userView">
      <div class="userdetail_title">
        <p>基本信息</p>
        <span @click="changeInfo">编辑</span>
      </div>
      <div class="userdetail_head" v-show="changeShow">
        <p>姓名：{{ userInfo.realName }}</p>
        <p class="userdetail_head__p">
          <span
            >{{ userInfo.sexLabel }}&nbsp;&nbsp;|&nbsp;&nbsp;{{
              userInfo.educationLabel
            }}</span
          >
          <span>手机号：{{ userInfo.cellphone }}</span>
          <span>邮箱：{{ userInfo.email }}</span>
        </p>
        <p class="userdetail_head__p">
          <span>身份证号：{{ userInfo.idCard }}</span>
          <span>出生日期：{{ userInfo.birth }}</span>
          <span>单位：{{ userInfo.companyName }}</span>
        </p>
        <p class="userdetail_head__p">
          <span>单位类型：{{ userInfo.companyTypeLabel }}</span>
          <span>职务：{{ userInfo.position }}</span>
          <span>服务主体：{{ userInfo.serviceMainLabel }}</span>
        </p>
      </div>
      <!-- 编辑 -->
      <div class="userdetail_head" v-if="!changeShow">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div class="userdetail_head_form">
            <el-form-item label="姓名" prop="realName">
              <el-input v-model="ruleForm.realName"></el-input>
            </el-form-item>
            <el-form-item label="学历" prop="education">
              <el-select v-model="ruleForm.education" placeholder="请选择学历">
                <el-option
                  v-for="item in educationList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="ruleForm.email"></el-input>
            </el-form-item>
          </div>
          <div class="userdetail_head_form">
            <el-form-item label="单位" prop="companyName">
              <el-input v-model="ruleForm.companyName"></el-input>
            </el-form-item>
            <el-form-item label="单位类型" prop="companyType">
              <el-select
                v-model="ruleForm.companyType"
                placeholder="请选择单位类型"
              >
                <el-option
                  v-for="item in companyType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="职务" prop="position">
              <el-input v-model="ruleForm.position"></el-input>
            </el-form-item>
          </div>

          <el-form-item label="服务主体" prop="serviceMain">
            <el-select
              v-model="ruleForm.serviceMain"
              placeholder="请选择服务主体"
            >
              <el-option
                v-for="item in serviceMains"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件照" prop="photo">
            <el-upload
              class="avatar-uploader"
              :headers="uploadHeaders"
              :action="upLoadUrl"
              :data="uploadData"
              accept=".png,.jpg,.jpeg"
              :on-success="handleSuccess"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="imageUrl"
                style="width: auto"
                :src="imageUrl"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"> </i>
              <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png/jpeg文件，且不超过2MB</div> -->
            </el-upload>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >提交审核</el-button
            >
            <el-button @click="changeShow = true">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="userView" v-loading="uploadLoading">
      <div class="userdetail_title">
        <p>申请表</p>
        <el-upload
          class="avatar-uploader"
          :headers="uploadHeaders"
          :action="upLoadUrl"
          :data="uploadData"
          accept=".png,.jpg,.jpeg,.pdf"
          :on-success="handleSuccessApply"
          :before-upload="beforeAvatarUploadApply"
          :show-file-list="false"
        >
          <span>上传盖章件</span>
        </el-upload>
      </div>
      <div class="userdetail_head">
        <p style="display: flex; align-items: center">
          申请表：<span
            style="color: #409eff; cursor: pointer"
            @click="openAppForm('first')"
            >申请表</span
          >
        </p>
        <p class="userdetail_head__p">
          <span
            >申请表盖章件：<span
              v-if="applyForm"
              style="color: #409eff; cursor: pointer"
              @click="openAppForm('last')"
              >申请表盖章件</span
            ></span
          >
        </p>
      </div>
    </div>

    <div
      class="userView"
      @mouseenter="editShow = true"
      @mouseleave="editShow = false"
    >
      <div class="userdetail_title">
        <p>证书</p>
        <span @click="addCert">添加</span>
      </div>
      <div
        class="userdetail_body"
        v-for="(item, index) in certList"
        :key="index"
      >
        <div class="userdetail_body__view">
          <div class="userdetail_body__pspan">
            <p>{{ item.certTypeTwoLabel }}</p>
          </div>
          <el-image
            style="width: 110px; height: 120px; margin-top: 10px"
            fit="cover"
            :src="item.certPhoto"
            :preview-src-list="[item.certPhoto]"
          >
          </el-image>
        </div>
        <div class="userdetail_body__view">
          <div class="userdetail_body__view_view"></div>
          <p>{{ item.certTypeOneLabel }}：{{ item.major }}</p>
        </div>
        <div class="userdetail_body__view">
          <div class="userdetail_body__view_view">
            <p
              v-show="editShow && item.statusLabel != '审核中'"
              @click="editChange(item)"
            >
              编辑
            </p>
            <span
              v-show="item.statusLabel == '审核中'"
              style="color: #c22c25"
              >{{ item.statusLabel }}</span
            >
            <!-- <p v-show="editShow">删除</p> -->
          </div>
          <p>发证时间：{{ item.certTime }}</p>
          <p style="margin-top: 12px">证书编号：{{ item.certCode }}</p>
          <p style="margin-top: 12px">职称：{{ item.title }}</p>
        </div>
      </div>
    </div>

    <!-- 添加证书 -->
    <addCertificate ref="addDialog" @refresh="getCertList"></addCertificate>
  </div>
</template>

<script>
import addCertificate from "./components/addCertificate.vue";

import { upLoadUrl, uploadHeaders, uploadData } from "@/utils/uploadConfig.js";
import {
  getVipUser,
  saveInfo,
  getAliOssAddress,
  getInfoStatus,
  getCertList,
  isCertStatus,
  updatePhone,
  getAppForm,
  uploadAppForm,
} from "../../api/moudles/user.js";
export default {
  components: {
    addCertificate,
  },
  data() {
    return {
      upLoadUrl,
      uploadHeaders,
      uploadData,
      certList: [],
      editStatus: 0,
      editShow: true,
      userInfo: {},
      changeShow: true,
      imageUrl: "",
      srcList: [],
      originForm: {},
      ruleForm: {
        realName: "",
        email: "",
        education: "",
        companyName: "",
        companyType: "",
        position: "",
        serviceMain: "",
        photo: "",
      },
      rules: {
        realName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        education: [
          {
            required: true,
            message: "请选择学历",
            trigger: "change",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "change",
          },
        ],
        companyName: [
          {
            required: true,
            message: "请输入单位名称",
            trigger: "change",
          },
        ],
        companyType: [
          {
            required: true,
            message: "请选择单位类型",
            trigger: "blur",
          },
        ],
        position: [
          {
            required: true,
            message: "请输入职位",
            trigger: "blur",
          },
        ],
        serviceMain: [
          {
            required: true,
            message: "请选择服务主体",
            trigger: "blur",
          },
        ],
        photo: [
          {
            required: true,
            message: "请上传证件照",
            trigger: "blur",
          },
        ],
      },
      // 学历
      educationList: [
        {
          label: "博士",
          value: 1,
        },
        {
          label: "硕士",
          value: 2,
        },
        {
          label: "本科",
          value: 3,
        },
        {
          label: "大专",
          value: 4,
        },
        {
          label: "高中",
          value: 5,
        },
        {
          label: "中专/中技",
          value: 6,
        },
        {
          label: "初中及以下",
          value: 7,
        },
      ],
      // 单位性质
      companyType: [
        {
          label: "中央企业",
          value: 1,
        },
        {
          label: "地方国企",
          value: 2,
        },
        {
          label: "事业单位",
          value: 3,
        },
        {
          label: "民营企业",
          value: 4,
        },
        {
          label: "自由职业",
          value: 5,
        },
        {
          label: "在校学生",
          value: 6,
        },
        {
          label: "其他",
          value: 7,
        },
      ],
      // 服务主体
      serviceMains: [
        {
          label: "法律服务工作委员会",
          value: 1,
        },
        {
          label: "钢木建筑分会",
          value: 2,
        },
        {
          label: "工程技术与BIM应用分会",
          value: 3,
        },
        {
          label: "工程项目管理与建造师分会",
          value: 4,
        },
        {
          label: "古建园林与环境工程分会",
          value: 5,
        },
        {
          label: "航天工程建设分会",
          value: 6,
        },
        {
          label: "核工业建设分会",
          value: 7,
        },
        {
          label: "混凝土分会",
          value: 8,
        },
        {
          label: "建筑安全与机械分会",
          value: 9,
        },
        {
          label: "建筑防水分会",
          value: 10,
        },
        {
          label: "建筑供应链与劳务管理分会",
          value: 11,
        },
        {
          label: "绿色建造与智能建筑分会",
          value: 12,
        },
        {
          label: "深基础与地下空间工程分会",
          value: 13,
        },
        {
          label: "石化建设分会",
          value: 14,
        },
        {
          label: "质量管理与监督检测分会",
          value: 15,
        },
        {
          label: "中小企业分会",
          value: 16,
        },
      ],
      applyForm: "",
      uploadLoading: false,
    };
  },
  created() {
    if (this.$store.state.user.userVip !== false) {
      this.getVipUser();
    }
    // this.getAliOss()
    this.getInfoStatus();
    this.getCertList();
    this.getApplyForm();
  },
  methods: {
    // 获取个人会员申请表地址
    getApplyForm() {
      getAppForm({
        success: (res) => {
          if (res.code == 0 && res.data) {
            this.applyForm = res.data; // 获取申请表地址
          }
        },
      });
    },
    openAppForm(type) {
      if (type == "first") {
        const url =
          "http://zjxadmin.a6edu.com/jmreport/view/1219790815880237056?token=bfa354404c3a4383a6a7225ed1895384&tenantId=1&member_code=" +
          this.userInfo.memberCode;
        window.open(url, "_blank");
      } else if (type == "last") {
        window.open(this.applyForm, "_blank"); // 打开申请表
      }
    },
    // 编辑
    editChange(item) {
      isCertStatus({
        data: {
          code: item.code,
        },
        success: (res) => {
          console.log("res", res);
          if (res.data.infoStatus == 1) {
            this.$message.warning("证书有待审核中的变更信息");
          } else {
            this.$refs.addDialog.openDialogChange(item);
          }
        },
      });
    },
    handleSuccess(file) {
      this.$message({
        message: "上传成功",
        type: "success",
      });
      this.imageUrl = file.data;
      this.ruleForm.photo = file.data;
    },
    handleSuccessApply(file) {
      if (file.code == 0 && file.data) {
        uploadAppForm({
          data: {
            url: file.data,
          },
          success: (res) => {
            if (res.code == 0 && res.data) {
              this.$message({
                message: "上传成功",
                type: "success",
              });
              this.applyForm = file.data; // 获取申请表地址
              this.getApplyForm();
            } else {
              this.$message.error("上传失败");
            }
            this.uploadLoading = false;
          },
          catch: () => {
            this.$message.error("上传失败");
            this.uploadLoading = false;
          },
        });
      } else {
        this.$message.error("上传失败");
        this.uploadLoading = false;
      }
    },
    beforeAvatarUploadApply(file) {
      const isLt2M = file.size / 1024 / 1024 < 200;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 200MB!");
      } else {
        this.uploadLoading = true;
      }
      return isLt2M;
    },
    // 获取个人信息待审核状态
    async getInfoStatus() {
      await getInfoStatus({
        success: (res) => {
          this.editStatus = res.data.infoStatus;
        },
      });
    },
    async getAliOss() {
      await getAliOssAddress({
        success: (res) => {
          localStorage.setItem("ossPath", res.data);
        },
      });
    },
    // 获取用户信息
    async getVipUser() {
      await getVipUser({
        success: (res) => {
          if (res.code === 403) {
            this.$store.commit("user/RESET_INFO");
            this.toLogin();
            return;
          }
          // 如果没有手机号,提示弹窗完善(强制)
          if (!res.data.cellphone) {
            this.$prompt("请完善手机号码（用于接收短信通告）", "提示", {
              confirmButtonText: "确定",
              confirmButtonClass: "newConfirm",
              showClose: false,
              showCancelButton: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              closeOnHashChange: false,
              inputPattern: /^1\d{10}$/,
              inputErrorMessage: "手机号格式不正确",
            }).then(({ value }) => {
              updatePhone({
                data: {
                  cellphone: value,
                },
                success: (res) => {
                  if (res.code != 200) {
                    this.$message.error(res.msg);
                    this.getVipUser();
                  } else {
                    this.$message({
                      type: "success",
                      message: res.msg,
                    });
                    this.getVipUser();
                  }
                },
              });
            });
          }
          if (res.data.flowStatusName == "冻结") {
            // 账号被冻结
            this.$confirm("当前账号已被冻结，无法使用", "提示", {
              confirmButtonText: "退出登录",
              showClose: false,
              showCancelButton: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              closeOnHashChange: false,
              type: "warning",
              center: true,
            }).then(() => {
              this.isLogin = false;
              this.userName = "会员";
              this.userHead = "";
              this.$store.commit("user/RESET_INFO");
              localStorage.removeItem("token");
              localStorage.removeItem("userName");
              localStorage.removeItem("userPhoto");
              setTimeout(() => {
                this.$message({
                  message: "退出成功，请重新登录!",
                  type: "success",
                });
                this.$router.replace("/login");
              }, 500);
              // 需要登录
            });
          }

          this.userInfo = res.data;
          if (this.userInfo.flow_status === 1) {
            //1\ 基本信息有审核中、审核通过，打开证书弹窗
            this.$refs.addDialog.openDialog();
          }
          if (this.userInfo.flow_status === 2) {
            //2\ 证书信息有审核中、审核通过,打开信息编辑
            this.changeShow = false;
          }

          const {
            realName,
            email,
            education,
            companyName,
            companyType,
            position,
            serviceMain,
            photo,
          } = res.data;

          localStorage.setItem("userName", realName);
          localStorage.setItem("userPhoto", photo);

          this.imageUrl = photo;
          this.originForm = {
            realName,
            email,
            education,
            companyName,
            companyType,
            position,
            serviceMain,
            photo,
          };
          this.ruleForm = {
            realName,
            email,
            education,
            companyName,
            companyType,
            position,
            photo,
          };
          if (serviceMain) {
            this.ruleForm.serviceMain = serviceMain;
          } else {
            this.ruleForm.serviceMain = 4;
          }
        },
      });
    },
    addCert() {
      this.$refs.addDialog.openDialog();
    },
    // 打开编辑按钮
    changeInfo() {
      // 编辑按钮打开之前 需要判断有无正在等待审核的
      if (this.editStatus == 1) {
        this.$message.warning("有待审核中的变更信息");
        return;
      }
      this.changeShow = false;
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 20MB!");
      }
      return isLt2M;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const newArr = [];
          Object.keys(this.ruleForm).forEach((key) => {
            if (this.ruleForm[key] != this.originForm[key]) {
              const newObj = {};
              newObj.type = key;
              newObj.msg = this.ruleForm[key];
              newArr.push(newObj);
            }
          });
          if (newArr.length) {
            this.saveInfo(newArr);
          } else {
            this.$message.error("您还没有修改任何信息！");
          }
        } else {
          return false;
        }
      });
    },
    // 获取证书列表
    async getCertList() {
      await getCertList({
        success: (res) => {
          // console.log('证书列表', res)
          this.certList = res.data;
          this.$store.dispatch("user/GET_USERINFO");
        },
      });
    },
    // 变更信息
    async saveInfo(params) {
      await saveInfo({
        data: {
          info: params,
        },
        success: (res) => {
          if (res.code == 200 || res.code == 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.$store.dispatch("user/GET_USERINFO");
            this.getInfoStatus();
            setTimeout(() => {
              this.changeShow = true;
            }, 1500);
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
  },
};
</script>

<style scoped>
.userView {
  min-height: 200px;
  background-color: #fff;
  margin-bottom: 20px;
  border: 1px solid #fff;
}

.userView:hover {
  border: 1px solid #c22c25;
}

.userdetail_title {
  display: flex;
  justify-content: space-between;
  height: 60px;
  font-weight: 500;
  line-height: 60px;
  padding: 0 20px;
  border-bottom: 1px solid #f2f2f2;
}

.userdetail_title p {
  font-size: 22px;
}

.userdetail_title span {
  cursor: pointer;
}

.userdetail_head {
  padding: 20px;
}

.userdetail_head p {
  margin: 10px 0;
}

.userdetail_head p > span {
  display: inline-block;
  width: 33%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.userdetail_head_form {
  width: 100%;
  display: flex;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px solid #dcdfe6;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.userdetail_body {
  display: flex;
  padding: 20px;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
}

.userdetail_head__p {
  display: flex;
  justify-content: space-between;
}

.userdetail_body__view {
  width: 33%;
}

.userdetail_body__view p {
  min-height: 20px;
}

.userdetail_body__view_view {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  height: 40px;
}

.userdetail_body__pspan {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

.userdetail_body__view_view p {
  margin-left: 30px;
  font-size: 15px;
}

.userdetail_body__view_view p:hover {
  cursor: pointer;
  color: #c22c25;
}
</style>
